import { render, staticRenderFns } from "./ClickCopy.vue?vue&type=template&id=23a3e3e5&"
import script from "./ClickCopy.vue?vue&type=script&lang=js&"
export * from "./ClickCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports